import angular from 'angular';
import '../../services/organization-user';
import '../../services/errors';
import { get } from 'lodash';

const module = angular.module('whyline.modals.link-users', [
	'whyline.services.errors',
]);

const LinkUsersModalController = function (
	$uibModalInstance,
	$translate,
	NotificationService,
	OrganizationUserService,
	ErrorService,
	$scope,
) {
	'ngInject'

	$scope.file = null;

	this.enableValidateButton = false;
	this.enableProcessButton = false;

	this.showResultMessage = false;

	this.totalRows = 0;
	this.rowCounter = 0;
	this.rowsProcessed = 0;
	this.errorsToShow = [];

	this.uploadFile = async file => {
		$scope.file = file;

		if ($scope.file.name && $scope.file.name.split('.').pop() === 'csv') {
			this.enableValidateButton = !!file;
		} else {
			this.enableValidateButton = false;
			NotificationService.Error($translate.instant('link-users.csv-file-extension-not-allowed'));
		}

		this.enableProcessButton = false;

		this.showResultMessage = false;
		this.errorsToShow = [];
	};

	this.validateFile = async () => {
		await Link('validate');
	};

	this.processFile = async () => {
		await Link('process');
	};

	const Link = async (action) => {
		if ($scope.file) {
			try {
				const { rowsCount, tasks } = await OrganizationUserService.Link($scope.file, 100, action);

				this.totalRows = rowsCount;

				await runSerial(tasks);

				this.enableProcessButton = true;
				this.showResultMessage = false;
				this.errorsToShow = [];

				let message = 'file-processed-successfully';

				switch (action) {
					case 'validate':
						message = 'link-users.csv-file-correct-data';
						break;
					case 'process':
						message = `link-users.csv-file-correct-process-${(parseInt(this.totalRows) === 1) ? 'singular' : 'plural'}`;
						break;
				}

				NotificationService.Success($translate.instant(message).replace('{totalRows}', this.totalRows));

				if (action === 'process') {
					this.cancel();
				}
			} catch (error) {
				this.enableProcessButton = false;
				this.errorsToShow = [];

				if (error.data) {
					const errorNotification = get(error.data, 'message', '');
					const errorData = get(error.data, 'data', []);
					const errorCode = get(error.data, 'httpCode', 0);

					if (errorCode === 409) {
						switch (errorNotification) {
							case 'duplicate-header':
								NotificationService.Error($translate.instant('duplicate_header'));
								return
							case 'incorrect-number-of-headers':
								NotificationService.Error($translate.instant('link-users.csv-file-incorrect-number-of-headers'));
								return

							case 'csv-file-wrong-data':
								NotificationService.Error($translate.instant('link-users.csv-file-wrong-data'));
								return
						}
					}

					if (errorCode === 409 && errorData.length) {
						for (const error of errorData) {
							const errorItem = {
								rowNumber: error.row,
								rowLabel: $translate.instant('link-users.csv-file-wrong-data-row-number').replace('{rowNumber}', error.row),
								errors: [],
							};

							if (error.email) {
								errorItem.errors.push($translate.instant(`link-users.csv-file-wrong-data-${error.email.result}-email`).replace('{email}', error.email.data));
							}

							if (error.externalId) {
								errorItem.errors.push($translate.instant(`link-users.csv-file-wrong-data-${error.externalId.result}-external-id`).replace('{externalId}', error.externalId.data));
							}

							this.errorsToShow.push(errorItem);
						}

						this.showResultMessage = true;
					}

					NotificationService.Warning($translate.instant(errorNotification));
				} else {
					ErrorService.handler(error);
				}
			}
		}
	}

	const runSerial = async (tasks) => {
		for (const task of tasks) {
			this.rowsProcessed += await processTask(task);
		}

		return (this.rowsProcessed) ? true : false;
	};

	const processTask = async (runTask) => {
		const result = await runTask();

		this.rowCounter += result;

		return result;
	}

	this.cancel = () => {
		$uibModalInstance.close('cancel');
	};
}

module.exports = module.controller('LinkUsersModalController', LinkUsersModalController);